<div class="p-4 rounded-xl">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-4">
      <app-back-button></app-back-button>

      <h2 class="text-lg font-semibold">{{ 'SETUP.INCOME.VALUES_TITLE' | translate }}</h2>
    </div>

    <button class="btn-primary" (click)="openPopup()">{{ 'SETUP.ADD_PLUS' | translate }}</button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
    [pageSize]="10"
    [enablePagination]="true"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    title="SETUP.INCOME.VALUE_TITLE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    [readonly]="isViewMode"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showDeletePopup"
    title="SETUP.INCOME.DELETE_VALUE"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()"
  ></app-popup>
</div>
